<section class="mu-home font-size-14" *ngIf="governmentBusinessDetailsForm">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <form [formGroup]="governmentBusinessDetailsForm">
            <div class="row">
              <div class="col-md-12 text-end">
                <a>
                  <button type="button" class="btn-actvtytp" (click)="downloadGovernmentBusiness()">DOWNLOAD</button>
                </a>
              </div>
              <div class="col-md-12 mb-2 empl-tptxt">
                <h3 class="mb-0">Task Details</h3>
              </div>
              <div class="row row-cols-2 row-cols-lg-4 g-2 g-lg-3 rwmxmobail">
                <div class="col">
                  <div class="p-2">
                    <label for="displayId" class="form-label">Task ID</label>
                    <input type="text" class="form-control" id="displayId" formControlName="displayId" />
                  </div>
                </div>
                <div class="col">
                  <div class="p-2">
                    <label for="taskName" class="form-label">Task Name <sup>*</sup></label>
                    <input class="form-control" id="taskName" formControlName="name" />
                  </div>
                </div>
                <div class="col">
                  <div class="p-2">
                    <label for="taskCategory" class="form-label">Category </label>
                    <input class="form-control" id="taskCategory" formControlName="taskCategory" />
                  </div>
                </div>
                <div class="col">
                  <div class="p-2">
                    <label for="taskSubCategory" class="form-label">Sub Category </label>
                    <input class="form-control" id="taskSubCategory" formControlName="taskSubCategory" />
                  </div>
                </div>
                <div class="col">
                  <div class="p-2">
                    <label for="departmentName" class="form-label">Department Name <sup>*</sup></label>
                    <input type="text" class="form-control" id="departmentName" formControlName="department" />
                    <app-validation
                      field="department"
                      [form]="governmentBusinessDetailsForm"
                      [error]="{
                        required: 'This is a mandatory field, Please enter Department name',
                        minLength: 'Department Name should have a minimum of 5 characters',
                        maxLength: 'Department Name should not exceed 30 characters'
                      }">
                    </app-validation>
                  </div>
                </div>
                <div class="col">
                  <div class="p-2">
                    <label for="officeName" class="form-label">Office Name <sup>*</sup></label>
                    <input type="text" class="form-control" id="officeName" formControlName="office" />
                    <app-validation
                      field="office"
                      [form]="governmentBusinessDetailsForm"
                      [error]="{
                        required: 'This is a mandatory field, Please enter Office name',
                        minLength: 'Office Name should have a minimum of 5 characters',
                        maxLength: 'Office Name should not exceed 30 characters'
                      }">
                    </app-validation>
                  </div>
                </div>
                <div class="col">
                  <div class="p-2">
                    <label for="taskType" class="form-label">Task Type <sup>*</sup></label>
                    <input class="form-control" id="taskType" formControlName="type" />
                  </div>
                </div>
                <div class="col">
                  <div class="p-2">
                    <label for="sectionReference" class="form-label">Section Reference</label>
                    <input type="text" class="form-control" id="sectionReference" formControlName="sectionReference" />
                    <app-validation
                      field="sectionReference"
                      [form]="governmentBusinessDetailsForm"
                      [error]="{
                        minLength: 'Section Reference should have a minimum of 5 characters',
                        maxLength: 'Section Reference should not exceed 40 characters'
                      }">
                    </app-validation>
                  </div>
                </div>
                <div class="col">
                  <div class="p-2">
                    <label for="ReceivedOn" class="form-label">Received on </label>
                    <input type="text" class="form-control" id="ReceivedOn" formControlName="createdDatetime" />
                  </div>
                </div>
                <div class="col">
                  <div class="p-2">
                    <label for="daysElapsed" class="form-label">Days Elapsed</label>
                    <input type="text" id="daysElapsed" class="form-control" formControlName="daysElapsed" />
                  </div>
                </div>
                <div class="col">
                  <div class="p-2">
                    <label for="location_gb" class="form-label">Location <sup>*</sup></label>
                    <select
                      class="form-select"
                      id="location_gb"
                      aria-label="Default select example"
                      [formControlName]="LOCATION_CONTROL_NAME">
                      <option [disabled]="true" selected value="">Select Location</option>
                      <option *ngFor="let location of locationOptions | keyvalue" [value]="location.key">
                        {{ location.value }}
                      </option>
                    </select>
                    <app-validation
                      field="location"
                      [form]="governmentBusinessDetailsForm"
                      [error]="{ required: 'This is a mandatory field, Kindly select location' }">
                    </app-validation>
                  </div>
                </div>
                <div class="col">
                  <div class="p-2">
                    <label for="responseDueBy" class="form-label">Response Due by</label>
                    <ng-container *ngIf="user?.userType === USER_TYPE.EMPLOYEE_ADMIN; else elseBlock">
                      <input
                        type="text"
                        id="responseDueBy"
                        class="form-control"
                        [formControlName]="RESPONSE_DUE_DATE_TIME_CONTROL_NAME" />
                    </ng-container>
                    <ng-template #elseBlock>
                      <input
                        type="date"
                        id="responseDueBy1"
                        class="form-control"
                        [formControlName]="RESPONSE_DUE_DATE_TIME_CONTROL_NAME" />
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="row my-2 rwmxmobail">
                <div class="col-md-3 col-12">
                  <div class="p-2">
                    <app-status-selector
                      [selectedStatus]="governmentBusiness?.status"
                      [categoryName]="governmentBusiness?.taskCategory"
                      [subCategoryName]="governmentBusiness?.taskSubCategory"
                      [moduleName]="MODULE_NAME"
                      [code]="governmentBusiness?.taskCode"
                      [isRequired]="true"
                      (onSelect)="onStatusSelected($event)"
                      (onStatusChange)="onStatusChange($event)">
                    </app-status-selector>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="p-2">
                    <label for="detailedStatus" class="form-label">Detailed Status <sup>*</sup></label>
                    <input type="text" class="form-control" id="detailedStatus" formControlName="detailedStatus" />
                    <app-validation
                      field="detailedStatus"
                      [form]="governmentBusinessDetailsForm"
                      [error]="{ required: 'This is a mandatory field, Please enter Detailed Status' }">
                    </app-validation>
                  </div>
                </div>
                <div class="col-md-3 col-12">
                  <div class="p-2">
                    <app-assign-to-selector
                      [selectedId]="governmentBusiness?.assignedTo"
                      [includeInactives]="true"
                      (selectedValueChange)="handleAssignToSelectedValue($event)"></app-assign-to-selector>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="p-2">
                    <label for="description" class="form-label">Description <sup>*</sup></label>
                    <textarea class="form-control" id="description" rows="4" formControlName="description"></textarea>
                  </div>
                </div>
                <div class="col-md-3 col-12">
                  <div class="p-2">
                    <app-attachment-list
                      [attachments]="governmentBusiness?.documents"
                      [companyEntityId]="governmentBusiness?.companyEntityId"></app-attachment-list>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <p>Upload Documents</p>
                <app-multiple-file-selector
                  [maxAllowedSizeInMB]="2"
                  [enableMultiSelect]="true"
                  [allowedTypes]="[
                    'application/pdf',
                    'image/jpeg',
                    'image/png',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    'message/rfc822',
                    'application/vnd.ms-excel.sheet.macroenabled.12'
                  ]"
                  (chooseFiles)="handleFileInput($event)"
                  (removeFiles)="clearSelectedFiles($event)"></app-multiple-file-selector>
              </div>
              <app-comment
                [comments]="governmentBusiness?.comments"
                (add)="addComment($event)"
                [statusChange]="statusValueChange"
                (mandatoryflag)="mandatoryflag($event)"
                (notifyChange)="getIfNotifySelected($event)"></app-comment>
              <div class="col-12 d-flex justify-content-end acvtypglastbtn">
                <a>
                  <button
                    type="button"
                    class="btn"
                    (click)="updateGovernmentBusinessDetails()"
                    [disabled]="!governmentBusinessDetailsForm.valid || isDisabled">
                    SAVE & EXIT
                  </button>
                </a>
                <a>
                  <button type="button" class="btn-discard" [routerLink]="GOVERNMENT_BUSINESS_SUMMARY_LINK">
                    CANCEL
                  </button>
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
